import type { FC } from 'react';

import NotFoundContent from 'components/UI/organisms/NotFoundContent/NotFoundContent';

const NotFoundPage: FC = () => <NotFoundContent />;

export default NotFoundPage;
